import styled from 'styled-components'

import { Trend } from '@root/entities/trend'
import { PnlUsdFormatted } from '@root/shared/core/format'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type Props = {
  pnl: BigNumber
} & ClassNameProps

export const HolderTablePnlCell: React.FC<Props> = ({ pnl, className }) => {
  const trend = Trend.of(pnl)

  return (
    <Root className={className}>
      <Pnl $trend={trend}>
        <PnlUsdFormatted pnl={pnl} />
      </Pnl>
    </Root>
  )
}

const Root = styled.div``

const Pnl = styled.span<{ $trend: Trend.Trend }>`
  color: ${({ $trend }) =>
    Trend.match($trend, {
      Up: () => 'var(--up-9)',
      Down: () => 'var(--down-9)',
      Neutral: () => 'var(--neutral-11)',
    })};

  font-size: 12px;
  font-weight: 500;
  line-height: normal;
`
